<template>
  <div class="home">
    <div class="level" style="margin-bottom: 10px">
      <p class="level-item has-text-centered">
        <img src="@/assets/logo-vjl.png" alt="" style="height: 80px; margin-right: 20px;" />
        <img src="@/assets/logo-full.png" alt="" style="height: 100px;" />
      </p>
    </div>
    <div class="container mb-4">
      <p class="
          is-size-1-fullhd
          is-size-2-widescreen
          is-size-2-desktop
          is-size-2-tablet
          is-size-3-touch
          is-uppercase
          has-text-weight-bold has-text-centered has-text-info
        " style="background-color: rgba(255, 255, 255, 0.7)">
        TRẮC NGHIỆM PHONG CÁCH HÀNH VI DISC
      </p>
    </div>
    <div class="has-text-centered my-3">
      <b-button class="is-uppercase has-text-weight-bold pulse-button" type="is-danger" size="is-large" @click="doTest">
        Làm Trắc Nghiệm
      </b-button>
    </div>
    <div class="container">
      <div class="notification is-info mb-4">
        <p class="
            is-size-2 is-size-3-touch
            has-text-centered
            is-uppercase
            has-text-weight-bold
          ">
          Giới thiệu chung
        </p>
        <!-- <p class="subtitle">Aligned with the right tile</p> -->
        <div class="content is-size-3 is-size-4-touch">
          <p>
            Nhiều người trong số chúng ta tin vào việc đối xử với người khác
            theo cách mình muốn được đối xử. Ðây được gọi là Nguyên tắc Vàng.
            Bên cạnh đó, chúng ta còn có một nguyên tắc sống thực tiễn khác mà
            Tiến sĩ Tony Alessandra gọi là Nguyên tắc Bạch Kim
          </p>
          <p>
            Đối xử với người khác theo cách họ muốn và cần được đối xử. Báo cáo
            DISC được cá nhân hóa này là công cụ giúp bạn phát triển và sử dụng
            các thế mạnh tự nhiên, đồng thời nhận diện, cải thiện và điều chỉnh
            những hạn chế của mình. Báo cáo này không đề cập đến các chuẩn mực
            hay lời phán xét nào mà tập trung vào các khuynh hướng tự nhiên có
            ảnh hưởng tới hành vi của bạn.
          </p>
          <p class="mb-0 has-text-weight-bold">Các kiểu hành vi:</p>
          <p>
            Hệ thống DISC tập trung vào các phong cách hành vi có thể quan sát
            được và bộc lộ ra bên ngoài bằng cách sử dụng thước đo độ thẳng thắn
            và độ cởi mở (xem bảng bên cạnh). Vì chúng ta có thể nhìn và nghe
            được những hành vi biểu lộ ra bên ngoài, chúng ta có thể “đọc” được
            người khác một cách nhanh chóng, chính xác và sử dụng kiến thức học
            được để nâng cao khả năng giao tiếp và phát triển các mối quan hệ.
            Mô hình này rất đơn giản, thực tế, dễ nhớ và dễ sử dụng.
          </p>
          <figure class="image is-5by5">
            <img src="@/assets/disc.png" style="max-width: 600px" />
          </figure>
        </div>
      </div>
      <div class="notification is-success mt-2">
        <div class="content">
          <p class="
              is-size-2 is-size-3-touch
              has-text-centered
              is-uppercase
              has-text-weight-bold
            ">
            Kết quả trắc nghiệm phong cách hành vi DISC
          </p>
          <!-- <p class="subtitle">With even more content</p> -->
          <div class="content is-size-3 is-size-4-touch">
            <strong class="mb-0">
              Báo cáo DISC này được chia thành hai phần:
            </strong>
            <ul class="mt-1">
              <li>
                <strong>Phần I: </strong> tập trung vào đặc điểm phong cách hành
                vi DISC của bạn. Vui lòng lưu ý rằng không có phong cách hành vi
                nào là “tốt nhất”. Mỗi phong cách hành vi đều có những điểm mạnh
                độc đáo và cơ hội để tiếp tục hoàn thiện và phát triển. Các mô
                tả hành vi được đề cập trong báo cáo này chỉ là khuynh hướng của
                nhóm hành vi của bạn và có thể hoặc không áp dụng cho bản thân
                bạn.
              </li>
              <li>
                <strong>Phần II: </strong> thảo luận khái niệm về khả năng thích
                ứng và đưa ra kế hoạch hành động cho bạn và những người tương
                tác với bạn.
              </li>
            </ul>
            <p class="mt-2">
              Ngoài việc thấu hiểu phong cách hành vi của cá nhân bạn, báo cáo
              này sẽ xác định các cách bạn có thể áp dụng những điểm mạnh hoặc
              điều chỉnh những điểm yếu trong phong cách hành vi để đáp ứng nhu
              cầu của người khác . Ðây gọi là khả năng thích ứng. Các nhà khoa
              học xã hội gọi đây là “Trí tuệ xã hội.” Gần đây có nhiều tài liệu
              viết về Chỉ số trí tuệ xã hội cũng quan trọng như Chỉ số thông
              minh (IQ) để đạt được thành công trong thế giới ngày nay. Trong
              một số trường hợp, trí tuệ xã hội thậm chí còn quan trọng hơn cả
              IQ. Khái niệm khả năng thích ứng sẽ được thảo luận chi tiết trong
              phần
              <strong>“Thích ứng hành vi là gì?”</strong> của bản báo cáo này.
            </p>
            <figure class="image is-5by5">
              <img src="@/assets/disc-2.png" style="max-width: 600px" />
            </figure>
          </div>
        </div>
      </div>
      <div class="has-text-centered my-3">
        <b-button class="is-uppercase has-text-weight-bold pulse-button" type="is-danger" size="is-large"
          @click="doTest">
          Làm Trắc Nghiệm
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { mapGetters } from "vuex";

export default {
  name: "Home",
  components: {
    // HelloWorld
  },
  computed: {
    ...mapGetters(["user"]),
  },
  beforeMount() {
    if (!this.user) {
      this.$store.dispatch("getCurrentUser");
    }
  },
  methods: {
    goToAdmin() {
      this.$router.push("/admin");
    },
    doTest() {
      if (this.user) {
        setTimeout(() => {
          this.$router.push("/test");
        }, 300);
      } else {
        setTimeout(() => {
          this.$router.push("/login");
        }, 300);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  background-image: url("../assets/banner.png");
  background-size: cover;
  padding-top: 50px;
  padding-bottom: 50px;
}

.fab {
  position: fixed;
  top: 10px;
  right: 10px;
}

.pulse-button {
  padding: 5px 30px 5px 30px;
  height: 100px;
  color: white !important;
  font-size: 1.3em;
  font-weight: light;
  animation: pulse 1.5s infinite;
}

.pulse-button:hover {
  animation: none;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 50px rgba(#5a99d4, 0);
  }

  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(#5a99d4, 0);
  }
}
</style>
